import React, {useEffect} from "react";
import classNames from "classnames";
import PropTypes, { checkPropTypes } from "prop-types";
// @mui/material components
import { useTheme} from "@mui/material/styles";
import { IconButton, Tooltip, MenuItem, MenuList, Grow, Paper, ClickAwayListener, Popper, Box, Badge } from "@mui/material";

// @mui/icons-material
import NotificationsIcon from '@mui/icons-material/Notifications';
import PowerSettingsNew from "@mui/icons-material/PowerSettingsNew";
// core components
import {useSelector, useDispatch} from 'react-redux'
import styles from "../assets/jss/material-dashboard-react/components/headerLinksStyle.js";
import { LOGOUT_USER } from "../../reducers/actionTypes.js";
import withRouterCompat from "../../actions/routerWrapper";


function AdminNavbarLinks(props) {
  const { type } = props;
  const [userdata, setuserdata] = React.useState({"id":'',"token":''});

  const user = useSelector(state => state.user)
  const dispatch = useDispatch();
  const theme = useTheme()
  const classes = styles(theme);
  const [openNotification, setOpenNotification] = React.useState(null);
  const [openProfile, setOpenProfile] = React.useState(null);
  const handleClickNotification = event => {
    if (openNotification && openNotification.contains(event.target)) {
      setOpenNotification(null);
    } else {
      setOpenNotification(event.currentTarget);
    }
  };
  const handleCloseNotification = () => {
    setOpenNotification(null);
  };




 
  const handleCloseLogout = () => {
    setOpenProfile(null);

    dispatch({
      type:LOGOUT_USER
    })

    window.location = "/"
    
  };




  useEffect(() => {
   
    setuserdata(user)
  
    })
  
      const notifications = type === "admin"
    ? [
        "Welcome to CT-Onlinq platform",
        "Check Dashboard for current available classes",
        "You’ve one active session in a class",
        "Monitor student activities and respond to messages"
      ]
    : [
        "Welcome to CT-Onlinq platform",
        "Check Dashboard for current available classes",
        "You’ve one active session in a class",
        "Contact your teacher/mentor for any issues"
      ];
    //console.log(userdata)


  return (

    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      {/* Notifications */}
      <Box>
        <Tooltip title="Notifications" arrow>
          <IconButton
            onClick={handleClickNotification}
            aria-controls={openNotification ? "notification-menu" : undefined}
            aria-haspopup="true"
            color="inherit"
          >
            <Badge badgeContent={notifications.length} color="error">
              <NotificationsIcon />
            </Badge>
          </IconButton>
        </Tooltip>
        <Popper
          open={Boolean(openNotification)}
          anchorEl={openNotification}
          placement="bottom-start"
          transition
          disablePortal
          sx={{ zIndex: 1302 }}
        >
          {({ TransitionProps }) => (
            <Grow {...TransitionProps}>
              <Paper>
                <ClickAwayListener onClickAway={handleCloseNotification}>
                  <MenuList autoFocusItem={Boolean(openNotification)} id="notification-menu">
                    {notifications.map((note, index) => (
                      <MenuItem key={index} onClick={handleCloseNotification}>
                        {note}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </Box>

      {/* Logout */}
      <Box>
        <Tooltip title="Log out" arrow>
          <IconButton onClick={handleCloseLogout} color="inherit">
            <PowerSettingsNew />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
}

AdminNavbarLinks.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object)
};
export default withRouterCompat(AdminNavbarLinks);